import Svg from '@doordash/component-svg'
import * as React from 'react'

// tslint:disable:max-line-length
export const Specialist: React.FunctionComponent = () => (
  <Svg
    width={129}
    height={95}
    fill="none"
    viewBox="0 0 300 300"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <style>
      {
        '.prefix__st0{fill:none;stroke:#3c5749;stroke-width:.5;stroke-miterlimit:10}.prefix__st2{fill:#28362c}.prefix__st3{fill:#806957}.prefix__st4{fill:#f7e3e1}.prefix__st5{fill:#725d4e}.prefix__st12,.prefix__st15,.prefix__st6,.prefix__st7{fill:none;stroke:#fff;stroke-width:.5;stroke-miterlimit:10}.prefix__st12,.prefix__st15,.prefix__st7{stroke:#101411}.prefix__st12,.prefix__st15{fill:#fff;stroke:#c7c6b7}.prefix__st15{fill:none;stroke:#a6c7ce}'
      }
    </style>
    <path
      d="M276.6 205.7c-61-70.1 58.1-149.8-68.1-129.8C136.2 87.4 147 34.1 91.1 51.1c-42.9 27.3 15.2 70.4-50.7 87.3-69.4 17.7-13.6 132.3 35.2 140.9 54.8-1.9 139.1.1 139.1.1s117.1-10.3 61.9-73.7z"
      fill="#e5f3f7"
    />
    <path
      className="prefix__st2"
      d="M136.2 123.2c3.6 3.9 5.6 9.9 2.9 16.4-2.8 6.5-1.4 16.6 7.2 24.4 4.1 3.7 7.6 9.6 6.7 17.3-1.8 13.8-26.7 18.8-34.8 20.4-14.4 2.8-21-9.2-24.4-17.9-3.3-8.7.6-26.9 7.4-32.7 6.8-5.8 18.5-25 18.8-31.1.3-6.1 1.4-15.9 1.4-15.9l7 1.5c0-.1-1.3 7.9 7.8 17.6z"
    />
    <path
      className="prefix__st3"
      d="M177.1 237.4c.4 1.8-14.9 15.6-17.3 13.1-15.8-16.1-26.5-31.5-37-49.7 4.2-7.3 19-23.2 22.2-13.1 3.3 10.9 31.7 47.9 32.1 49.7z"
    />
    <path
      className="prefix__st4"
      d="M129.9 218.2s29.1-6.9 29.1-8.9c0-4.7-16.9-35.1-19.2-38.2s-14.3-10.6-22.7-7.7c.1 7.2 2 17.8 2 17.8l10.8 37z"
    />
    <path
      className="prefix__st5"
      d="M117.4 164.4c-9.3-4.7-10.4-25.9-10.4-26.6s-21.2-.9-26.8-8c4.9 13.8 11.7 15.6 10.6 23.7-.6 4.5 4.3 21.9 18.7 16.8 5-1.7 11.8-3.9 7.9-5.9z"
    />
    <path
      className="prefix__st3"
      d="M84.4 117.3c-.5 2-.6 16.7 4.7 25.8 2.2 3.7 15.8 12.3 21.1 12.7 4.2.3 6.4-2.7 9.3-6.7 3.6-5 5.4-11.2 5.3-14.8-.2-9.3 4.3-17.2-2-31-1.4-3.1-32 0-32 0l-6.4 14z"
    />
    <path
      className="prefix__st6"
      d="M114.9 128.3c1.1.8.1 10.8-9.2 10-8.6-.8-9.5-11.8-8.8-12.3 0-.1 10.5-3.3 18 2.3zM129.5 130.7c1 2.5-1.6 9.6-6.3 9.3-6.5-.3-5.7-10.4-5.1-10.9 1-.8 10.5-1 11.4 1.6zM115.2 130.9s1.4-.2 2.4.4"
    />
    <path
      className="prefix__st4"
      d="M118.2 163.3c-3.1-1.8-4.6 10.7-18.8 3.7-3.7-1.8-7.6-6.7-10.6-6.3-12.1 9-16.1 24.1-17.8 30.3-2.5 13.8-4.9 70.7-2.4 79.5.3.3 57.2.3 57.9.6.3-3.1 9.6-49.2 10.7-52.4 7.6-21.6-6.3-48.1-19-55.4z"
    />
    <path
      className="prefix__st3"
      d="M156.1 270.5s-71.8-6.6-86.6-8.6c-2.9-.4-9.2-4.5-8.3-11.3.5-3.6 6.3-9.9 16.6-10.1 2.8-.1 12.3 1.8 23 4.6 38.7 10.3 58.2 14.2 58.2 14.2l-2.9 11.2z"
    />
    <path
      className="prefix__st3"
      d="M81 260.5c-.5.8-6.6 1.2-12.7.9-6.3-2.6-10.3-8.3-10.4-10.2-1.5-23.9.2-38 2.4-61.2.6-6.7 1.7-13.1 3.1-17.2 1.7-4.9 6.5-7.9 6.5-7.9s13.3-.4 18.7 7.5c1.1 1.6 1 11.4-.6 20.7-1.5 9.5-6 65.7-7 67.4z"
    />
    <path
      className="prefix__st4"
      d="M54.6 222.3c.7 3 32.3-1 32.3-1s11.5-49.8 2.8-57.8c-8.7-8.1-23.1 3.1-24.4 4-5.2 3.2-12.4 47.8-10.7 54.8z"
    />
    <path
      className="prefix__st2"
      d="M84.5 108.6s-12.4-3.1-10.2-12.4 13.3-9.8 16.4-5.8c3.1 4 3.1 11.5 3.1 11.5l-9.3 6.7z"
    />
    <path className="prefix__st7" d="M68.2 97s3.4 10.3 14.7 11.3" />
    <path
      d="M89.7 163.5c-.7-.7-1.5-1.2-2.2-1.6-11 9.1-14.8 23.2-16.5 29.2-1.1 5.9-1 18.6-.8 31.9 8.2-.6 16.7-1.7 16.7-1.7s11.4-49.8 2.8-57.8z"
      fill="#f2d1cd"
    />
    <path
      className="prefix__st2"
      d="M127.4 113.3s4.9-11.9-4.8-16.2c-8.7-3.8-18.6-4.9-31 3.1-9.6 6.2-13.3 16-23.9 17.7-22.3 3.7-20.8 18.1-20.8 24.8 0 6.8-6.7 12.9-14.2 15.1-15.7 4.6-20 50 20.8 42.1 5.2-1 14.6-8.7 13.8-17.4-.5-5.3-.8-8.4 1.3-10.9s7.8-4.5 14.6-4.2c8.3.4 11.6-2.4 13.6-10 1.4-5.4-3-21-7-25.2-6.5-6.8-4-11.3 1.3-9.5 4.5 1.5 4.5-.1 8.4-7.3 3.4-6.3 13.4-8.2 13.4-8.2l14.5 6.1z"
    />
    <path
      className="prefix__st7"
      d="M108.2 103.3c-2.9-.2-21.3-1.4-27.1 13.6-2.6 6.8 6.4 16.1-3.6 21.4-10 5.3-19 6.6-18.9 15 .1 8.4 3.2 21.9-3.2 27.3-9.4 7.9-23.9 5-23.9 5M24.6 154.8c1.8-.6 14.6 0 16-9.3 1.3-9.3 2.3-16.6 7.6-22.9 9-10.6 22.3-6.3 35.6-14.6"
    />
    <path
      d="M82.6 108c1.1.4 1.9.6 1.9.6l9.3-6.7s0-1.2-.2-3c-.7.4-1.3.8-2 1.2-3.6 2.4-6.4 5.2-9 7.9z"
      fill="#151e17"
    />
    <path
      d="M82.5 107.6s5.2-6.9 11.5-9.2"
      fill="none"
      stroke="#ff3008"
      strokeMiterlimit={10}
    />
    <path
      fill="none"
      stroke="#3c5749"
      strokeWidth={0.517}
      strokeMiterlimit={10}
      d="M12 279h286"
    />
    <path
      className="prefix__st12"
      d="M157.5 264.2l-49.2-.3s-.4.8.1 3c.4 1.7 2.2 2.9 4.6 3.2 2.8.3 43.9.7 43.9.7"
    />
    <path
      d="M133.7 186.4s8 15.3 4.3 29.6"
      fill="none"
      stroke="#e5bbb7"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M83.3 120c-1.5.8-4.3 5.9-2.6 11 2.1 6.5 6 7.6 9.2 6.3 3.3-1.4 6.3-7.4 3.4-13.2-2.8-5.9-7.9-5.3-10-4.1z"
      fill="#a6c7ce"
    />
    <path
      className="prefix__st15"
      d="M125.9 112.6s-3.7-10.8-16.5-11c-16-.3-21.4 14.1-21.6 18"
    />
    <path
      className="prefix__st6"
      d="M82.9 123.2c-1.9 1-2.8 3.3-2.2 6.1.6 2.8 2.4 5.3 5.1 5.9s4.8-2.2 4.6-5.4c-.1-3.6-3-8.9-7.5-6.6z"
    />
    <path
      className="prefix__st15"
      d="M89.5 137.2s5.3 15.6 28.1 15.9M120.5 151.8s-1.7-.4-2.4.3c-.7.6-.6 2 .1 2.4.7.4 2.7.4 2.7.4"
    />
    <path
      className="prefix__st15"
      d="M122.5 149.8c.8-.3 2.9-.5 3.7.7.9 1.2.8 2.8.5 3.5-.3.8-1.1 1.8-2 2-1.1.3-2.5-.1-3.2-.6-.9-.7-1.5-3.1-.7-4.3 1-1.2 1.7-1.3 1.7-1.3z"
    />
    <path
      className="prefix__st0"
      d="M180.3 146.3l-.1 9.2 10.9-8.5s52 0 61.3-.3c10.8-.3 20.4-9 19.6-19.9s-7.5-19.3-21-20.1c-13.5-.8-69.8-.7-80.2.8-10.8 1.6-15.5 7.3-15.8 18-.3 10.7 7.5 19.1 13.4 19.9 5.9.8 11.9.9 11.9.9zM179 118.5l69.9-.3M178.7 125.4l54.7.4M179 133.3h52.8"
    />
    <path
      d="M130.4 115.9c2.9 6 10 9.7 11.7 15.3 4.2 13.5-7.3 15.3-1.8 25.7 3.3 6.1 14.9 12.4 14.9 12.4"
      fill="none"
      stroke="#28362c"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      className="prefix__st3"
      d="M156.1 270.5s-71.8-6.6-86.6-8.6c-2.9-.4-9.2-4.5-8.3-11.3.5-3.6 6.3-9.9 16.6-10.1 2.8-.1 12.3 1.8 23 4.6 38.7 10.3 58.2 14.2 58.2 14.2l-2.9 11.2zM88.1 193.1c-1.6 9.5-6 65.7-7.1 67.4"
    />
    <path
      className="prefix__st5"
      d="M81 260.5c.4-.6 1.2-8.8 2.2-19.4-2.5-.4-4.4-.7-5.4-.6-10.3.2-16.1 6.5-16.6 10.1-.5 4.1 1.6 7.3 4 9.2 1 .6 2 1.2 3.1 1.6 6.1.3 12.2-.1 12.7-.9z"
    />
    <path
      className="prefix__st12"
      d="M170.5 196.2c-2 1.2-14.9 73.3-13.7 74.4 1.2 1.1 98.5 1.1 99.9-.5 1.4-1.6 14.5-75.8 13.6-75-1.4 1.3-97.8-.1-99.8 1.1z"
    />
    <path
      d="M217.8 224.4c-2.7-.1-8.5 2.7-8.4 8.1.1 5.4 2.8 8.8 8.1 8.5 5.3-.3 8-4 8-7.7 0-3.1-1.6-8.6-7.7-8.9z"
      fill="none"
      stroke="#c7c6b7"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      fill="#fff"
      stroke="#28362c"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      d="M43.9 270.5l222.4.8.5 7.5-224.6-.2z"
    />
  </Svg>
)

export default Specialist
